import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import history from './routers/history';
import { store } from './redux/store';
import Admin from './components/Admin';

import 'react-perfect-scrollbar/dist/css/styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-phone-number-input/style.css';
import 'react-mde/lib/styles/css/react-mde-all.css';
import './styles/sb-admin-2.css';
import './App.scss';

const App: FC = () => {
  return (
    <div className="App" id="wrapper">
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Admin />
        </ConnectedRouter>
      </Provider>
    </div>
  );
};

export default App;
